import React, { useState, useEffect, ChangeEventHandler, useRef } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import CustomButton from "../../components/CustomButton/CustomButton";
import InputField from "../../components/InputField/InputField";
import setInputValues from "../../utils/helpers/setInputValue";
import { ArrowLeft } from "react-bootstrap-icons";
import PageHeader from "../../components/PageHeader/PageHeader";
import EditorField from "../../components/EditorField/EditorField";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import "./Wall_listing.scss";
import encrypt from "../../utils/helpers/encrypt";
import { validateUploadedFile } from "../../utils/helpers/validateFileUpload";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { format } from "date-fns";
import { hideToast, showToast } from "../../store/Toast/toast.slice";

interface WallPost {
  post_status: string;
  postType: number;
  wantToSendPushNotification:number;
}

// postType: 1 --> newsfeed
//           0 --> CulturalClub

const AddWallPost: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [postInfo, setPostInfo] = useState<WallPost>({
    post_status: "",
    postType: 0,
    wantToSendPushNotification:0
  });
  const cmpMounted = useRef(false);
  const location = useLocation();
  const type = location.pathname.replace("/post/", "");
  const { posttype, name } = location.state || {};
  const [fileInputKey, setFileInputKey] = useState(0);
  const [addFileButtonVisible, setAddFileButtonVisible] = useState(false);
  const [hoveredFileIndex, setHoveredFileIndex] = useState(-1);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [files, setFiles] = useState<any[]>([]);
  const [filePreview, setFilePreview] = useState<(string | File)[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [scheduleDate, setScheduleDate] = useState("");
  const [editorContent, setEditorContent] = useState<string>("");
  const [charCount, setCharCount] = useState(0);
  const [error, setError] = useState("");
  const [fileError, setFileError] = useState("");
  const maxLength = 2000;

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    console.log(type);
    postInfo.postType = posttype;

    console.log(postInfo.postType);

  }, []);


  const stripHtmlTags = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    let plainText = tempDiv.textContent || tempDiv.innerText || "";

    plainText = plainText.replace(/<\/?(p|div|br)>/g, "\n").trim();

    return plainText;
  };

  const updateCharCountAndValidation = (data: any) => {
    const plainText = stripHtmlTags(data);
    const charLength = plainText.length;

    if (charLength > 2000) {
      setError("Character limit exceeded (2000 max)");
    } else {
      setError("");
    }

    setCharCount(charLength);
  };

  const handleEditorChange = (event: any, editor: any) => {
    const data = editor.getData();
    updateCharCountAndValidation(data);

    if (charCount <= 2000) {
      setPostInfo({
        ...postInfo,
        post_status: data,
      });
    }
  };

  const handleEditorBlur = (event: any, editor: any) => {
    const data = editor.getData();
    updateCharCountAndValidation(data);
  };


  const handleSubmit = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    // console.log(postInfo)

    if (files.length === 0 && postInfo.post_status.length === 0) {
      setError("Please enter post");
      setFileError("Please upload media");
      return;
    }

    if (charCount > 2000) {
      dispatch(
        showToast(
          "Character limit exceeded 2000. Please reduce number of characters."
        )
      );
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const trimmedData = stripHtmlTags(postInfo.post_status).substring(0, 2000);
    
    setPostInfo((prev) => ({
      ...prev,
      post_status: trimmedData,
      wantToSendPushNotification:postInfo.wantToSendPushNotification

    }));
    console.log(postInfo,'postinfo')

    try {
      dispatch(showLoader("Loading data..."));
      const formData = new FormData();

      let encryptedData;

      // if(scheduleDate){
      //   encryptedData = encrypt({
      //     post_status: postInfo.post_status,
      //     postType: postInfo.postType,
      //     display_time: scheduleDate
      //   });
      // } else{
      //   encryptedData = encrypt({
      //     post_status: postInfo.post_status,
      //     postType: postInfo.postType,
      //   });
      // }

      if (scheduleDate) {
        encryptedData = encrypt({
          postType: postInfo.postType,
          wantToSendPushNotification:postInfo.wantToSendPushNotification,
          display_time: scheduleDate,
          ...(postInfo.post_status
            ? { post_status: postInfo.post_status }
            : {}),
        });
      } else {
        encryptedData = encrypt({
          postType: postInfo.postType,
          wantToSendPushNotification:postInfo.wantToSendPushNotification,

          ...(postInfo.post_status
            ? { post_status: postInfo.post_status }
            : {}),
        });
      }

      formData.append("data", encryptedData);
      for (let i = 0; i < files.length; i++) {
        formData.append("media_file", files[i]);
      }
      console.log(formData,'formData')
      const response = await postMultipartDetails(APIList.ADD_POST, formData);
      console.log(response);

      if (response.Status === "Failed") {
        dispatch(showToast(response.message));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      if (posttype === 1) {
        navigate("/wall");
      } else {
        navigate("/culturalPost");
      }
    } catch (err) {
      dispatch(showToast("Some error occurred while uploading post."));
      setTimeout(() => dispatch(hideToast()), 3000);
      console.log(err);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleBackToGroup = () => {
    if (posttype === 1) {
      navigate("/wall");
    } else {
      navigate("/culturalPost");
    }
  };


  const MAX_FILES = 10;


  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files;

    if (selectedFiles) {
      const currentFileCount = files.length;
      const totalFileCount = currentFileCount + selectedFiles.length;

      // Check if total files exceed 10
      if (totalFileCount > MAX_FILES) {
        dispatch(
          showToast(`You can only upload a maximum of ${MAX_FILES} files.`)
        );
        setTimeout(() => dispatch(hideToast()), 3000);
        event.target.value = ""; // Reset input value to prevent further uploads
        return;
      }

      const maxImageSize = 10.1 * 1024 * 1024;
      const maxVideoSize = 25.1 * 1024 * 1024;
      const maxPdfSize = 20.1 * 1024 * 1024;
      const allowedFileTypes = [
        "image/jpeg",
        "image/png",
        "video/mp4",
        "application/pdf",
      ];

      const newFilePreviews: (string | File)[] = [];
      const validFiles: File[] = [];

      // const checkVideoDuration = (file: File): Promise<boolean> => {
      //   return new Promise((resolve) => {
      //     const videoElement = document.createElement("video");
      //     const fileURL = URL.createObjectURL(file);

      //     videoElement.src = fileURL;
      //     videoElement.addEventListener("loadedmetadata", () => {
      //       const duration = videoElement.duration;
      //       URL.revokeObjectURL(fileURL); // Revoke URL after use
      //       resolve(duration <= 60); // 60 seconds = 1 minute
      //     });
      //   });
      // };

      const processFiles = async () => {
        for (const file of Array.from(selectedFiles)) {
          // Validate real extension + MIME, and reject deceptive double-extension
          // names (e.g. file.php.png, file.png.svg) before the MIME check.
          const wallValidation = validateUploadedFile(
            file,
            {
              png: ["image/png"],
              jpg: ["image/jpeg", "image/jpg"],
              jpeg: ["image/jpeg", "image/jpg"],
              mp4: ["video/mp4"],
              pdf: ["application/pdf"],
            },
            "PNG, JPG, MP4 and PDF"
          );
          if (!wallValidation.valid) {
            dispatch(
              showToast(`Invalid file "${file.name}". ${wallValidation.message}`)
            );
            setTimeout(() => dispatch(hideToast()), 3000);
            continue; // Skip invalid files
          }

          // Check for valid file types first
          if (!allowedFileTypes.includes(file.type)) {
            dispatch(
              showToast(
                `Invalid file type "${file.name}". Only PNG, JPG, MP4, and PDF are allowed.`
              )
            );
            setTimeout(() => dispatch(hideToast()), 3000);
            continue; // Skip invalid files
          }

          // Check for valid file sizes
          if (file.type.startsWith("video/")) {
            // if (file.size > maxVideoSize) {
            //   dispatch(showToast(`Video file "${file.name}" exceeds the 25 MB size limit.`));
            //   setTimeout(() => dispatch(hideToast()), 3000);
            //   continue;
            // }

            // Check if the video duration exceeds 1 minute
            // const isValidDuration = await checkVideoDuration(file);
            // if (!isValidDuration) {
            //   dispatch(
            //     showToast(`Video "${file.name}" is longer than 1 minute.`)
            //   );
            //   setTimeout(() => dispatch(hideToast()), 3000);
            //   continue;
            // }
          } else if (file.type.startsWith("image/")) {
            if (file.size > maxImageSize) {
              dispatch(
                showToast(
                  `Image file "${file.name}" exceeds the 10 MB size limit.`
                )
              );
              setTimeout(() => dispatch(hideToast()), 3000);
              continue;
            }
          } else if (file.type === "application/pdf") {
            if (file.size > maxPdfSize) {
              dispatch(
                showToast(
                  `PDF file "${file.name}" exceeds the 20 MB size limit.`
                )
              );
              setTimeout(() => dispatch(hideToast()), 3000);
              continue;
            }
          }

          // If the file passes all checks, add it to the valid files
          validFiles.push(file);

          // For images, generate object URL for preview
          if (file.type.startsWith("image/")) {
            newFilePreviews.push(URL.createObjectURL(file));
          } else {
            newFilePreviews.push(file); // For videos and PDFs, just push the file itself
          }
        }

        const updatedFiles = [...files, ...validFiles];
        setFiles(updatedFiles);
        const updatedFilePreviews = [...filePreview, ...newFilePreviews];
        setFilePreview(updatedFilePreviews);

        // Ensure that the file input gets reset after upload
        event.target.value = "";
        setAddFileButtonVisible(
          updatedFiles.length > 0 && updatedFiles.length < MAX_FILES
        );
        setFileError("");
      };

      processFiles();
    }
  };

  const formatDateToUTC = (date: Date) => {
    const utcDate = new Date(date.toUTCString()); // Convert to UTC Date object
    return format(utcDate, "dd-MM-yyyy HH:mm:ss");
  };

  const handleDateChange = (date: Date | null) => {
    const now = new Date();

    if (date && date < now) {
      dispatch(showToast("Selected time cannot be earlier than now."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
    setSelectedDate(date);
    date ? setScheduleDate(formatDateToUTC(date)) : setScheduleDate("");
  };

  const handleKeyDown = (e: any) => {
    e.preventDefault(); // Prevent any keyboard input
  };

  const filePreviewStyle = {
    width: "8.500rem",
    height: "9rem",
    padding: "0.200rem",
    margin: "0.800rem 0.300rem",
    borderRadius: "0.500rem",
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);

    const updatedFilePreviews = [...filePreview];
    updatedFilePreviews.splice(index, 1);

    setFiles(updatedFiles);
    setFilePreview(updatedFilePreviews);

    if (updatedFiles.length > 0 && updatedFiles.length < MAX_FILES) {
      setAddFileButtonVisible(true);
    }
  };

  const isToday = (date: Date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const buttons = [
    {
      label: "Back To List",
      theme: "danger",
      icon: <ArrowLeft />,
      onClick: handleBackToGroup,
    },
  ];

  return (
    <LayoutContainer title="Add Post">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className={`page-header-icon fa fa-plus`}></i>
          Create New Post
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      <div className="mx-4">
        <form className="add-group-form" onSubmit={handleSubmit}>
          <div className="d-flex flex-column gap-2 mb-5">
            {/* <EditorField
              name="post_status"
              label="Post"
              type="text"
              value={postInfo.post_status}
              placeholder="Enter Post"
              required={true}
              onChangeInput={(ev) => setInputValues(ev, postInfo, setPostInfo)}
              // onChangeInput={handleEditorChange}
            /> */}
            <label htmlFor="post_status" className="fw-medium">
              Post
            </label>
            <div className="editor-container">
              {/* <CKEditor
              editor={ClassicEditor}
              data={postInfo.post_status}
              config={{
                placeholder: "Enter Post",
                link: {
                  defaultProtocol: "https://", // Ensures https:// is added to links without protocol
                  addTargetToExternalLinks: true,
                },
              }}
              onChange={handleEditorChange}
              onBlur={handleEditorBlur}
            /> */}
              <CKEditor
                editor={ClassicEditor as any}
                data={postInfo.post_status}
                onChange={handleEditorChange}
                onBlur={handleEditorBlur}
              />
              <small className="char-count">{charCount} / 2000</small>
              {error && (
                <span className="text-danger fw-bold font-12">{error}</span>
              )}
            </div>
            <div className="form-check mb-3 mt-3">
  <input
    className="form-check-input"
    type="checkbox"
    id="pushNotification"
    checked={postInfo.wantToSendPushNotification === 1}
    onChange={(e) =>
      setPostInfo((prev) => ({
        ...prev,
        wantToSendPushNotification: e.target.checked ? 1 : 0,
      }))
    }
  />
  <label className="form-check-label" htmlFor="pushNotification">
    Send Push Notification
  </label>
</div>

            <div className="mb-4">
              <div className="my-4 d-flex flex-column align-items-md-center flex-md-row justify-content-md-between">
                <div>
                  <h6 className="mb-1">Upload Your Media</h6>
                </div>
                <div>
                  <h6>MaxFile : 10</h6>
                </div>
              </div>

              <div className="upload_file_area">
                <div className="custom-file-input">
                  <input
                    type="file"
                    id="fileUpload"
                    key={fileInputKey}
                    multiple
                    accept="image/png, image/jpeg, video/mp4, application/pdf"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  {/* <div className="file-previews" style={{ display: "flex" }}>
                    {filePreview.length > 0 ? null : (
                      <label htmlFor="fileUpload" id="custom-file-label">
                        <p id="drop_file">Drop file here to upload</p>
                      </label>
                    )}
                    {filePreview.map((preview, index) => (
                      <div
                        key={index}
                        className="file-preview"
                        onMouseEnter={() => setHoveredFileIndex(index)}
                        onMouseLeave={() => setHoveredFileIndex(-1)}
                      >
                        {typeof preview === "string" ? (
                          <div
                            style={{
                              ...filePreviewStyle,
                              position: "relative",
                            }}
                          >
                            <img
                              src={preview}
                              alt={`File ${index}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "1rem",
                              }}
                            />

                          </div>
                        ) : (
                          <div
                            style={{
                              ...filePreviewStyle,
                              position: "relative",
                            }}
                          >
                            <video
                              controls
                              width="100%"
                              height="100%"
                              style={{ borderRadius: "1rem" }}
                            >
                              <source
                                src={URL.createObjectURL(preview)}
                                type="video/mp4"
                              />
                            </video>

                          </div>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => handleRemoveFile(index)}
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div> */}
                  <div className="file-previews" style={{ display: "flex" }}>
                    {filePreview.length > 0 ? null : (
                      <label htmlFor="fileUpload" id="custom-file-label">
                        <p id="drop_file">Drop file here to upload</p>
                      </label>
                    )}
                    {filePreview.map((preview, index) => (
                      <div
                        key={index}
                        className="file-preview"
                        onMouseEnter={() => setHoveredFileIndex(index)}
                        onMouseLeave={() => setHoveredFileIndex(-1)}
                      >
                        {typeof preview === "string" ? (
                          // For Image Previews
                          <div
                            style={{
                              ...filePreviewStyle,
                              position: "relative",
                            }}
                          >
                            <img
                              src={preview}
                              alt={`File ${index}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "1rem",
                              }}
                            />
                          </div>
                        ) : (
                          // Differentiate between video and PDF files
                          <div
                            style={{
                              ...filePreviewStyle,
                              position: "relative",
                            }}
                          >
                            {preview.type === "video/mp4" ? (
                              // Video Preview
                              <video
                                controls
                                width="100%"
                                height="100%"
                                style={{ borderRadius: "1rem" }}
                              >
                                <source
                                  src={URL.createObjectURL(preview)}
                                  type="video/mp4"
                                />
                              </video>
                            ) : preview.type === "application/pdf" ? (
                              // PDF Preview (showing a PDF icon or placeholder)
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "1rem",
                                  backgroundColor: "#f2f2f2", // Background for the icon
                                }}
                              >
                                <i className="fas fa-file-pdf fa-3x"></i>{" "}
                                {/* FontAwesome PDF icon */}
                              </div>
                            ) : null}
                          </div>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => handleRemoveFile(index)}
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                  <div className="btn-add-new-file">
                    {addFileButtonVisible ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                          const fileUpload =
                            document.getElementById("fileUpload");
                          if (fileUpload) {
                            fileUpload.click();
                          }
                          e.currentTarget.blur();
                        }}
                      >
                        Add File
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
              <div style={{ minHeight: "70px" }}>
                <p className="mt-2 mb-0 font-weight-media ">
                  Allowed Multiple Image/Video/PDF Selection
                </p>
                <p className="mt-1 mb-0 font-weight-media ">
                  Allowed Extensions For Image : .jpeg, .jpg, .png. (Size: 10
                  MB)
                </p>
                <p className="mt-1 mb-0 font-weight-media ">
                  Allowed Extensions For PDF : .pdf (Size: 20 MB)
                </p>
                {/* <p className="mt-1 mb-2 font-weight-media ">
                  Allowed Extensions For Video : .mp4. (Size : 25 MB)
                </p> */}
                {fileError && (
                  <p className="text-danger fw-bold font-12">{fileError}</p>
                )}
              </div>
            </div>

            <div className="mb-4">
              <div className="col-md-6 ">
                <h6>Schedule Post</h6>
              </div>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                showTimeSelect
                // readOnly
                timeFormat="HH:mm"
                timeIntervals={15}
                minDate={new Date()}
                //             minTime={selectedDate && isToday(selectedDate) ? new Date() : new Date(new Date().setHours(0, 0, 0, 0))}
                // maxTime={new Date(new Date().setHours(23, 59))}
                dateFormat="dd-MM-yyyy HH:mm"
                placeholderText="Select date and time"
                className={`mf-admin-inputfield`}
                onKeyDown={handleKeyDown}
                showMonthDropdown // Add month dropdown
                showYearDropdown // Add year dropdown
                dropdownMode="select"
                isClearable
              />
            </div>

            <div style={{ width: "5rem" }}>
              <CustomButton type="submit" size="md" theme="red">
                Add
              </CustomButton>
            </div>
          </div>
        </form>
      </div>
    </LayoutContainer>
  );
};

export default AddWallPost;
